import {GlobalAnalyticsVariablesInterface, TrackFieldErrorInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackFieldErrorPayloadCase = (
  currentPage: string,
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
): TrackFieldErrorInterface => {
  const data = {
    eventType: 'fieldFailed',
    fieldList: `${currentPage}|${payload}`
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}
